export default __webpack_public_path__ + "static/media/home.10af80c6.svg";